export default "__VITE_ASSET__C8Qd4Dhb__"